import { Notify } from 'quasar';

type Type = 'positive' | 'negative';

interface ToasterOptions {
  classes?: string;
  html?: boolean;
  message: string;
  timeout?: number;
  type: Type;
}

let notifier = null;

function showToaster(options: ToasterOptions) {
  if (notifier) notifier();
  notifier = Notify.create({
    classes: options.classes,
    html: options.html ?? false,
    message: options.message,
    position: 'top',
    timeout: options.timeout ?? 5000,
    type: options.type,
  });
}

export { showToaster };
